/* unplugin-vue-components disabled */import { render } from "./MySet.vue?vue&type=template&id=6d503da6&scoped=true"
import script from "./MySet.vue?vue&type=script&lang=js"
export * from "./MySet.vue?vue&type=script&lang=js"

import "./MySet.vue?vue&type=style&index=0&id=6d503da6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d503da6"]])

export default __exports__